export var apiPath='/v2/users';var actionType='ASSIGNABLE_USERS';export default actionType;